import Api from "@/services/Api";

const state = {
	users: [],
	roles: []
};
const getters = {
	users: state => state.users,
	roles: state => state.roles
};
const mutations = {
	async GET_USERS(state, payload) {
		let result = await Api.get("wemail/users");
		payload.context.loading = false;
		state.users = result.data.data;
	},
	async GET_ROLES(state, payload) {
		let result = await Api.get("wemail/roles");
		payload.context.loading = false;
		state.roles = result.data.roles;
	}
};
const actions = {
	GET_USERS({ commit }, payload) {
		commit("GET_USERS", payload);
	},
	GET_ROLES({ commit }, payload) {
		commit("GET_ROLES", payload);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
